import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { H1 } from '../../../components/atoms/Heading/Heading';
import { SearchField } from '../../../components/atoms/SearchField/SearchField';
import { css, styled } from '../../theme/styled';

export type LayoutProps = {
  searchBoxShadow?: boolean;
  wideSearchField?: boolean;
};

export const StyledBox = styled(Box)<LayoutProps>`
  flex-shrink: 0;
  align-items: center;

  ${SearchField} {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;

    ${({ searchBoxShadow, theme }) =>
      searchBoxShadow &&
      css`
        box-shadow: ${theme.shadows.large};
        &:focus {
          box-shadow: unset;
        }
      `}
  }

  ${H1} {
    flex-shrink: 0;
    margin-top: ${(props) => props.theme.sizes.xxsmall};
    margin-bottom: ${(props) => props.theme.sizes.xxsmall};
  }

  ${({ theme, wideSearchField }) =>
    css`
      width: 100%;

      @media ${theme.device.tablet} {
        display: flex;

        ${SearchField} {
          width: auto;
          min-width: ${wideSearchField ? '340px' : 'auto'};
          margin-left: ${theme.sizes.medium};
        }

        ${SearchField} input {
          line-height: 1.3;
        }
      }
    `}
`;
